import { FC, useState } from "react";
import Modal from "../../components/shared/Modal/Modal";
import { Reason } from "../../models/supplier.model";
import SupplierBlockedReasons from "./supplier-blocked-reasons";
import Field from "../../components/shared/Field/Field";
import { ServiceSupplier } from "../../services/service-supplier";
import { NotificationManager } from "react-notifications";
import { useTranslation, Trans } from "react-i18next";

type Props = {
  supplierId: string,
  supplierName: string,
  reasons: Reason[],
  block: boolean,
  show: boolean,
  onClose: () => void,
  onSuccess: (isBlacklist: boolean, reasons: Reason[]) => void,
}
const BlockSupplierModal : FC<Props> = ({ show, onClose, onSuccess, supplierId, supplierName, block, reasons}) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'blockSupplier' });
  const [reason, setReason] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const onSave = async () => {
    setIsSaving(true);
    try {
      const response = await ServiceSupplier.putBlock(supplierId, block, reason);
      NotificationManager.success(t('notification.success', 'Sparat'));
      onSuccess(response.isBlacklist, response.reasons);
      onClose();
    } catch (e) {
      NotificationManager.error((e as Error).toString(), t('notification.error', 'Fel'));
    }
    setIsSaving(false);
  }

  const title = block ? t('title.block', 'Spärra leverantör') : t('title.unblock', 'Ta bort spärr');
  const body = (
    <p style={{color: "var(--gray-700)"}}>
      <Trans t={t} i18nKey="description" context={block?'block':'unblock'} values={{supplierName}}>
        Hindra <span style={{fontWeight: 500, color: "var(--gray-900)"}}>{supplierName}</span> från att väljas i projekt.
      </Trans>
    </p>
  );

  supplierId;
  return (
    <Modal show={show} setShow={onClose} title={title} buttonInfo={{
      label: block ? t('button.block', 'Spärra') : t('button.unblock', 'Ta bort spärr'),
      action: onSave,
      loaderShow: isSaving,
      disabled: !reason,
    }}>
      <div style={{display: "flex", flexDirection: "column", gap: "16px", fontSize: "14px"}}>
        {body}
        <SupplierBlockedReasons reasons={reasons}/>
        <Field label={t('label.reason', 'Skriv anledning')} value={reason} onChange={setReason} />
      </div>
    </Modal>
  );
}

export default BlockSupplierModal;
